import { PrimitiveUnit } from "../../models/unit.model";

export class Action extends PrimitiveUnit {
  permission: number;
  exists: number;
}
